import React, { memo, useContext, useMemo, useState, useRef, useEffect } from 'react';
import { createUseStyles, useTheme, Icon, Text } from '@Sage/hoi-poi-ui';
import CopilotSidebarChatTab from "./CopilotSidebarChatTab";
import CopilotSidebarAgentsTab from "./CopilotSidebarAgentsTab";
import CopilotSidebarHistoryTab from "./CopilotSidebarHistoryTab";
import CopilotSidebarHeader from "./CopilotSidebarHeader";
import AgentsIcon from "./components/AgentsIcon/Agents";
import CopilotLightIcon from "./components/CopilotLightIcon";
import { CopilotContext } from "../Context";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'CopilotSidebar');
var _ref2 = /*#__PURE__*/React.createElement(CopilotLightIcon, null);
var _ref3 = /*#__PURE__*/React.createElement(Text, {
  type: "caption"
}, "Chat");
var _ref4 = /*#__PURE__*/React.createElement(Text, {
  type: "caption"
}, "History");
var _ref5 = /*#__PURE__*/React.createElement(Text, {
  type: "caption"
}, "Agents");
var _ref6 = /*#__PURE__*/React.createElement(CopilotSidebarHistoryTab, null);
var _ref7 = /*#__PURE__*/React.createElement(CopilotSidebarAgentsTab, null);
const CopilotSidebar = _ref => {
  let {
    onClose,
    userData
  } = _ref;
  const theme = useTheme();
  const classes = useStyles();
  const [activeTab, setActiveTab] = useState('chat');
  const {
    refreshAgents
  } = useContext(CopilotContext);
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      refreshAgents();
      isFirstRender.current = false;
    }
  }, [refreshAgents]);
  const chatProps = useMemo(() => ({
    locale: userData === null || userData === void 0 ? void 0 : userData.locale
  }), [userData === null || userData === void 0 ? void 0 : userData.locale]);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mainContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.verticalTabs
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.copilotIcon
  }, _ref2), /*#__PURE__*/React.createElement("button", {
    className: activeTab === 'chat' ? `${classes.tabButton} ${classes.tabButtonActive}` : classes.tabButton,
    onClick: () => setActiveTab('chat')
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.tabIcon,
    name: "chat",
    color: theme.colors.primary.black
  }), _ref3), /*#__PURE__*/React.createElement("button", {
    className: activeTab === 'history' ? `${classes.tabButton} ${classes.tabButtonActive}` : classes.tabButton,
    onClick: () => setActiveTab('history')
  }, /*#__PURE__*/React.createElement(Icon, {
    className: classes.tabIcon,
    name: "clock",
    color: theme.colors.primary.black
  }), _ref4), /*#__PURE__*/React.createElement("button", {
    className: activeTab === 'agents' ? `${classes.tabButton} ${classes.tabButtonActive}` : classes.tabButton,
    onClick: () => setActiveTab('agents')
  }, /*#__PURE__*/React.createElement(AgentsIcon, {
    className: classes.tabIcon
  }), _ref5)), /*#__PURE__*/React.createElement("div", {
    className: classes.tabContent
  }, /*#__PURE__*/React.createElement(CopilotSidebarHeader, {
    onClose: onClose
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.tabContentContainer
  }, activeTab === 'chat' && /*#__PURE__*/React.createElement(CopilotSidebarChatTab, chatProps), activeTab === 'history' && _ref6, activeTab === 'agents' && _ref7))));
};
export default /*#__PURE__*/memo(CopilotSidebar);